import BlobStoreClient from '@locuslabs/blob-client';
import * as Request from '../request';
import * as Config from '../config';

const blobClient = async () => {
    const accessToken = await Config.getAccessToken();
    return BlobStoreClient(accessToken);
};

const putBlobRequest = Request.makeRequest(blobClient, 'putBlob', Request.id);
const getBlobRequest = Request.makeRequest(blobClient, 'getBlob', Request.responseUrl);

/*
 * Makes a call to the blob store to upload the image pixels.
 * @sig uploadPixels :: (Image, String, String, JWT) -> BlobId
 */
const uploadPixels = async (image, contentType, entityType) => {
    const params = { bucket: `${entityType}.locuslabs.com`, folder: 'poi', type: contentType };
    return putBlobRequest(params, image);
};

/*
 * Get a blob url from the blob store
 * @sig getBlob :: (Image, JWT) -> URL
 */
const getBlob = async image => {
    const params = { bucket: 'img.locuslabs.com', folder: 'poi' };
    return getBlobRequest(image.blobId, params);
};

const Blob = {
    uploadPixels,
    getBlob,
};

export { Blob };
